/* unplugin-vue-components disabled */import { render } from "./culture.vue?vue&type=template&id=b7780874"
import script from "./culture.vue?vue&type=script&lang=js"
export * from "./culture.vue?vue&type=script&lang=js"

import "./culture.vue?vue&type=style&index=0&id=b7780874&lang=css"

import exportComponent from "F:\\vue2.0+ vant\\2024年项目集合\\元羿官网项目集合\\元羿中文版本\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__